import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Badge } from "@/components/ui/badge";

interface Category {
  name: string;
  count: number;
}

interface HelpCategoryNavProps {
  categories: Category[];
  selectedCategory: string | null;
  onSelectCategory: (category: string | null) => void;
}

const HelpCategoryNav = ({ categories, selectedCategory, onSelectCategory }: HelpCategoryNavProps) => {
  return (
    <div className="space-y-2">
      <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-4">
        Categories
      </h3>
      <ScrollArea className="h-[calc(100vh-250px)]">
        <div className="space-y-1">
          <Button
            variant={selectedCategory === null ? "secondary" : "ghost"}
            className="w-full justify-between"
            onClick={() => onSelectCategory(null)}
          >
            <span>All Articles</span>
            <Badge variant="outline" className="ml-2">
              {categories.reduce((acc, cat) => acc + cat.count, 0)}
            </Badge>
          </Button>
          {categories.map((category) => (
            <Button
              key={category.name}
              variant={selectedCategory === category.name ? "secondary" : "ghost"}
              className="w-full justify-between"
              onClick={() => onSelectCategory(category.name)}
            >
              <span className="truncate">{category.name}</span>
              <Badge variant="outline" className="ml-2">
                {category.count}
              </Badge>
            </Button>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};

export default HelpCategoryNav;
